import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';
import { getRef, restProps, SmallContext } from '../utils';

import styles from './Button.less';

const cxb = cx.bind(styles);

/**
 * **Access:**
 * ```js
 * import { Flyouts } from '@iss/client-react-components'
 *
 * <Flyouts.Button/>
 * ```
 *
 * Use this as a trigger for a flyout.
 *
 * @visibleName Button
 * @component
 */
export default class FlyoutButton extends React.Component {
  static Light = React.forwardRef((props, ref) => <FlyoutButton {...props} ref={ref} kind="light" />);
  static Dark = React.forwardRef((props, ref) => <FlyoutButton {...props} ref={ref} kind="dark" />);
  static Special = React.forwardRef((props, ref) => <FlyoutButton {...props} ref={ref} kind="special" />);
  static SpecialDark = React.forwardRef((props, ref) => <FlyoutButton {...props} ref={ref} kind="special-dark" />);
  static Date = React.forwardRef((props, ref) => <FlyoutButton {...props} ref={ref} kind="date" />);

  static contextType = SmallContext;

  static propTypes = {
    /** Render with a visual indication that the flyout is open. (**&lt;Flyouts.Triggered&gt;** sets this for you) */
    open: PropTypes.bool,

    /** render small variant */
    small: PropTypes.bool,

    disabled: PropTypes.bool,

    /** An enumeration of one of the styles. */
    kind: PropTypes.oneOf(['dark', 'light', 'special', 'special-dark', 'date']).isRequired,
  };

  static defaultProps = {
    kind: 'light',
    disabled: false,
  };

  ref = React.createRef();

  getDOMNode() {
    return getRef(this);
  }

  focus() {
    this.getDOMNode().focus();
  }

  render() {
    const { kind, children, open, disabled, ...props } = this.props;
    return (
      <Type
        {...restProps(FlyoutButton, props)}
        ref={this.ref}
        as="button"
        type="button"
        className={cxb('root', kind, { open, small: SmallContext.isSmall(this) })}
        disabled={disabled}
      >
        {children}

        {kind === 'date' ? <i className="icon-calendar" /> : <i className="icon-chevron-down" />}
      </Type>
    );
  }
}
